import React, { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import seting from "../../assets/seeting.png";
import axios from "axios";
import { apiKey } from "../../config/config";
import { languageHelper } from "../../config/helperFunctions";

function DashboardDropdown() {
  const defaultLang = localStorage.getItem("rms-lang") || "text_en";
  const [showDropdown, setShowDropDown] = useState(false);
  const [outlets, setOutlets] = useState([]);
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const navigate = useNavigate();

  const handleLogout = () => {
    axios
      .post(
        `${apiKey}/api/rms/admin/logout`,
        {},
        {
          headers: {
            Authorization: `Bearer ${user?.token}`,
          },
        }
      )
      .then((res) => {})
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        localStorage.removeItem("rms-admin");
        navigate("/admin");
      });
  };

  useEffect(() => {
    axios
      .get(`${apiKey}/api/rms/admin/get-outlets/${user?.user.outlet_id}`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        }
      }).then(res => {
        setOutlets(res.data[0])
      }).catch(err => {
        console.error(err)
      })
  }, [user?.token, user?.user.outlet_id])
  return (
    <>
    <div className="text-xs font-semibold mt-2">
      <h2>{user?.user.name}</h2>
      <h3>{outlets?.name}</h3>
    </div>
      <span className="relative">
        <button onClick={() => setShowDropDown(!showDropdown)}>
          <div>
            <img src={seting} alt="" height="20" width="50" />
          </div>
        </button>
        <div
          className={
            (showDropdown ? "block " : "hidden ") +
            "absolute top-13 left-6 -translate-x-[90%] bg-white text-base z-50 float-left py-2 list-none text-left rounded shadow-lg min-w-44"
          }
        >
          <div className=" text-sm py-2 text-[#7B20C7] px-3 font-semibold block w-full whitespace-nowrap bg-transparent text-blueGray-700">
            <NavLink
              to="./manageUser/addUserFormm"
              className="flex gap-2 items-center"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 448 512"
                className="fill-[#7B20C7]"
                height="16"
                width="25"
              >
                <path d="M144 0a80 80 0 1 1 0 160A80 80 0 1 1 144 0zM512 0a80 80 0 1 1 0 160A80 80 0 1 1 512 0zM0 298.7C0 239.8 47.8 192 106.7 192h42.7c15.9 0 31 3.5 44.6 9.7c-1.3 7.2-1.9 14.7-1.9 22.3c0 38.2 16.8 72.5 43.3 96c-.2 0-.4 0-.7 0H21.3C9.6 320 0 310.4 0 298.7zM405.3 320c-.2 0-.4 0-.7 0c26.6-23.5 43.3-57.8 43.3-96c0-7.6-.7-15-1.9-22.3c13.6-6.3 28.7-9.7 44.6-9.7h42.7C592.2 192 640 239.8 640 298.7c0 11.8-9.6 21.3-21.3 21.3H405.3zM224 224a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zM128 485.3C128 411.7 187.7 352 261.3 352H378.7C452.3 352 512 411.7 512 485.3c0 14.7-11.9 26.7-26.7 26.7H154.7c-14.7 0-26.7-11.9-26.7-26.7z" />
              </svg>

              <span className="">{languageHelper(defaultLang, 'manage user') || "Manage User"}</span>
            </NavLink>
          </div>

          <div className=" text-sm py-2 text-[#7B20C7] px-3 font-semibold block w-full whitespace-nowrap bg-transparent text-blueGray-700">
            <NavLink to="./changeProfile" className="flex gap-2 items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
                className="fill-[#7B20C7]"
                height="16"
                width="25"
              >
                <path d="M471.6 21.7c-21.9-21.9-57.3-21.9-79.2 0L362.3 51.7l97.9 97.9 30.1-30.1c21.9-21.9 21.9-57.3 0-79.2L471.6 21.7zm-299.2 220c-6.1 6.1-10.8 13.6-13.5 21.9l-29.6 88.8c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l88.8-29.6c8.2-2.7 15.7-7.4 21.9-13.5L437.7 172.3 339.7 74.3 172.4 241.7zM96 64C43 64 0 107 0 160V416c0 53 43 96 96 96H352c53 0 96-43 96-96V320c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H96z" />
              </svg>
              <span className="">
                {languageHelper(defaultLang, 'edit profile') || "Edit Profile"}</span>
            </NavLink>
          </div>

          <div className=" text-sm py-2 text-[#7B20C7] px-3 font-semibold block w-full whitespace-nowrap bg-transparent text-blueGray-700">
            <NavLink to="./changePassword" className="flex gap-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 448 512"
                className="fill-[#7B20C7]"
                height="16"
                width="25"
              >
                <path d="M144 144v48H304V144c0-44.2-35.8-80-80-80s-80 35.8-80 80zM80 192V144C80 64.5 144.5 0 224 0s144 64.5 144 144v48h16c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256c0-35.3 28.7-64 64-64H80z" />
              </svg>

              <span className="">{languageHelper(defaultLang, "change password") || "Change Password"}</span>
            </NavLink>
          </div>

          <div className=" text-sm py-2 text-[#7B20C7] px-3 font-semibold block w-full whitespace-nowrap bg-transparent text-blueGray-700">
            <button className="flex gap-2 items-center" onClick={handleLogout}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
                className="fill-[#7B20C7]"
                height="16"
                width="25"
              >
                <path d="M377.9 105.9L500.7 228.7c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3L377.9 406.1c-6.4 6.4-15 9.9-24 9.9c-18.7 0-33.9-15.2-33.9-33.9l0-62.1-128 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l128 0 0-62.1c0-18.7 15.2-33.9 33.9-33.9c9 0 17.6 3.6 24 9.9zM160 96L96 96c-17.7 0-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-53 0-96-43-96-96L0 128C0 75 43 32 96 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32z" />
              </svg>

              <span className="">{languageHelper(defaultLang, "logout") || "Logout"}</span>
            </button>
          </div>
        </div>
      </span>
    </>
  );
}

export default DashboardDropdown;
